import { render } from "./DefaultBatchTopInfoContainer.vue?vue&type=template&id=abc2065c"
import script from "./DefaultBatchTopInfoContainer.vue?vue&type=script&lang=js"
export * from "./DefaultBatchTopInfoContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__